import { Component, Input } from '@angular/core';
import { ItemStatusIndicator } from '../item-status-indicator/item-status-indicator.enum';

@Component({
    selector: 'base-item-status-indicator',
    templateUrl: './base-item-status-indicator.component.html',
    styleUrls: ['./base-item-status-indicator.component.scss']
})
export class BaseItemStatusIndicatorComponent {
    private _status: ItemStatusIndicator;
    private _useAbbreviation: boolean = false;
    private _statusText: string = '';

    @Input() 
    get status() { 
        return this._status;
    }

    set status(value: ItemStatusIndicator) {
        this._status = value;
        this.setStatusText(value, this.useAbbreviation);
    };

    @Input()
    get useAbbreviation() { 
        return this._useAbbreviation;
    }

    set useAbbreviation(value: boolean) {
        this._useAbbreviation = value;
        this.setStatusText(this.status, value);
    };

    @Input() title: string = '';

    get statusText() {
        return this._statusText;
    }

    ItemStatusIndicator = ItemStatusIndicator;

    private setStatusText(status: ItemStatusIndicator, useAbbreviation: boolean) {
        this._statusText = (useAbbreviation ? status?.substring(0, 3) : status) ?? '';
    }
}